var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "listPage" },
    [
      _c(
        "b-row",
        { staticClass: "mt-2 mb-5 justify-content-start" },
        [
          _c(
            "b-col",
            { attrs: { cols: "4", lg: "2", xl: "1" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "btnFilter",
                  on: {
                    click: function ($event) {
                      _vm.displayFilter = !_vm.displayFilter
                    },
                  },
                },
                [
                  _vm.displayFilter
                    ? _c("i", { staticClass: "fa-light fa-minus" })
                    : _c("i", { staticClass: "fa-light fa-plus" }),
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("filter.fltr")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "4", lg: "2", xl: "1" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "btnFilter",
                  on: {
                    click: function ($event) {
                      return _vm.refreshInbox()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa-light fa-rotate-right" }),
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("common.rfrsh")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.displayFilter
        ? _c(
            "b-row",
            { staticClass: "justify-content-start" },
            [
              _c(
                "b-col",
                {
                  staticClass: "filter-item mb-5",
                  attrs: { sm: "6", lg: "3", cols: "12" },
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "filter-item-title",
                      attrs: { for: "tracking-name" },
                    },
                    [_vm._v(_vm._s(_vm.$t("tracking.file_name")))]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "filter-item-content" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.Name,
                          expression: "Name",
                        },
                      ],
                      class: {
                        "filter-item-input": true,
                        "filter-item-input-complete": _vm.Name,
                      },
                      attrs: {
                        id: "tracking-name",
                        type: "text",
                        placeholder: _vm.$t("tracking.name"),
                      },
                      domProps: { value: _vm.Name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.Name = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "filter-item mb-5",
                  attrs: { sm: "6", lg: "3", cols: "12" },
                },
                [
                  _c("datetime-picker-custom", {
                    staticClass: "z-1",
                    class: {
                      "filter-item-input": true,
                      "filter-item-input-complete": _vm.dateBegin,
                    },
                    attrs: {
                      format: "DD/MM/YYYY H:i:s",
                      inputLabel: _vm.$t("common.date_start_label"),
                      customInputParentClass: "filter-item-content",
                      customInputClass: "w-100",
                      maxLength: 19,
                      placeholderValue: _vm.$t(
                        "common.datetime_picker_empty_date"
                      ),
                      inputIcon: "fa-solid fa-calendar",
                    },
                    model: {
                      value: _vm.dateBegin,
                      callback: function ($$v) {
                        _vm.dateBegin = $$v
                      },
                      expression: "dateBegin",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "filter-item mb-5",
                  attrs: { sm: "6", lg: "3", cols: "12" },
                },
                [
                  _c("datetime-picker-custom", {
                    staticClass: "z-1",
                    class: {
                      "filter-item-input": true,
                      "filter-item-input-complete": _vm.dateEnd,
                    },
                    attrs: {
                      format: "DD/MM/YYYY H:i:s",
                      inputLabel: _vm.$t("common.date_end_label"),
                      customInputParentClass: "filter-item-content",
                      customInputClass: "w-100",
                      maxLength: 19,
                      placeholderValue: _vm.$t(
                        "common.datetime_picker_empty_date"
                      ),
                      inputIcon: "fa-solid fa-calendar",
                    },
                    model: {
                      value: _vm.dateEnd,
                      callback: function ($$v) {
                        _vm.dateEnd = $$v
                      },
                      expression: "dateEnd",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "d-flex flex-row-reverse mt-3",
                  attrs: { lg: "3", cols: "12" },
                },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm" },
                      on: {
                        click: function ($event) {
                          return _vm.applyFilter()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("common.srch")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-3",
                      attrs: { size: "sm", disabled: !_vm.hasInputFilter },
                      on: { click: _vm.clearFilterFields },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("filter.clr_fltr_field")) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.TracksList.length > 0
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-end" },
            [
              _c(
                "b-button",
                {
                  staticClass: "btnFilter_2 mx-3",
                  on: {
                    click: function ($event) {
                      return _vm.extractCSV()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa-light fa-upload fs-14px" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "fab-label" }, [
                    _vm._v(_vm._s(_vm.$t("common.extract_list"))),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activateSpinner
        ? _c("spinner")
        : _vm.TracksList.length > 0
        ? _c("b-table", {
            staticClass: "table table-striped",
            attrs: {
              hover: "",
              fields: _vm.fields,
              items: _vm.TracksList,
              selectable: _vm.TracksList.length > 0,
              "empty-text": _vm.$t("common.security.no_result"),
            },
            on: { "row-selected": _vm.seeTracksDetails },
            scopedSlots: _vm._u([
              {
                key: "cell(FileName)",
                fn: function (data) {
                  return [_c("span", [_vm._v(_vm._s(data.value))])]
                },
              },
              {
                key: "cell(Date)",
                fn: function (data) {
                  return [_c("span", [_vm._v(_vm._s(_vm.getDate(data.value)))])]
                },
              },
            ]),
          })
        : _c("div", { staticClass: "d-flex justify-content-center" }, [
            _c("span", { staticClass: "noResult" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("common.no_result")) + "\n    "
              ),
            ]),
          ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-5" },
        [
          _c(
            "b-col",
            [
              _c("cm-pagination", {
                attrs: {
                  maxResultsByPage: _vm.paginationObject.maxResults,
                  firstIndex: _vm.paginationObject.firstIndex,
                  nbResultsTotal: _vm.paginationObject.nbResultsTotal,
                  refreshEvent: _vm.paginationObject.refresh,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }